/*
 * @Description: 
 
 * @Date: 2018-12-21 17:03:28
 * @LastEditors: 王佳兴
 * @LastEditTime: 2019-01-07 13:07:45
 */
export const initSearch = {
  data() {
    return {};
  },
  methods: {},
  watch: {
    $route(to, from) {
      this.initWatchRouteChange();
    }
  },
  mounted() {}
};
